import PropTypes from "prop-types";
import Autocomplete from "@mui/material/Autocomplete";

import MDInput from "components/MDInput";

const normalizeOptions = (options) =>
  options.map((opt) => (typeof opt === "string" ? { value: opt, label: opt } : opt));

const findOption = (options, value) => options.find((opt) => opt.value === value) || null;

function MDAutocomplete({
  label,
  options,
  value,
  onChange,
  fullWidth = true,
  disableClearable = true,
  ...rest
}) {
  const normalized = normalizeOptions(options);

  return (
    <Autocomplete
      disableClearable={disableClearable}
      fullWidth={fullWidth}
      options={normalized}
      value={findOption(normalized, value)}
      getOptionLabel={(option) => option?.label ?? ""}
      isOptionEqualToValue={(option, selected) => option.value === selected?.value}
      onChange={(_, newValue) => onChange(newValue?.value ?? "")}
      renderInput={(params) => <MDInput {...params} label={label} fullWidth={fullWidth} />}
      {...rest}
    />
  );
}

MDAutocomplete.propTypes = {
  label: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.shape({
        value: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
      }),
    ])
  ).isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  fullWidth: PropTypes.bool,
  disableClearable: PropTypes.bool,
};

export default MDAutocomplete;
